import {
  createUserFamily as createUserFamilyApi
  , getUserFamilyById as getUserFamilyByIdApi
  , updateUserFamily as updateUserFamilyApi
  , updateUserFamilyAddress as updateUserFamilyAddressApi,
  createUserFamilyMember as createUserFamilyMemberApi,
  getUserFamilyMemberById as getUserFamilyMemberByIdApi,
  updateUserFamilyMember as updateUserFamilyMemberApi
} from "./SpatApi";
import { showErrorToast, showSuccessToast } from "../utils/Toasts";

// Create a new UserFamily
export async function handleCreateUserFamily(data) {
  try {
    const response = await createUserFamilyApi(data);
    if (response?.status === 201 || response?.status === 200) {
      showSuccessToast(response?.data?.message || "UserFamily created successfully.");
      return true;
    } else {
      showErrorToast(response?.data?.message || response?.message || "Something went wrong while creating UserFamily.");
      return false;
    }
  } catch (error) {
    showErrorToast(error?.message || "Something went wrong while creating UserFamily");
    return false;
  }
}

// Fetch UserFamily by ID
export async function fetchUserFamilyById(familyId) {
  try {
    const response = await getUserFamilyByIdApi(familyId);
    if (response?.status === 200) {
      return response.data;
    } else {
      showErrorToast(response?.data?.message || response?.message || "Failed to fetch family data");
      return false;
    }
  } catch (error) {
    showErrorToast(error?.message || "Error fetching family details");
    return false;
  }
}


// Update family details
export async function updateUserFamily(updatedUserFamilyData) {
  try {
    const response = await updateUserFamilyApi(updatedUserFamilyData);
    if (response?.status === 200 || response?.status === 201) {
      showSuccessToast("UserFamily updated successfully");
      return true; // Return true on success
    } else {
      showErrorToast(response?.data?.message || response?.message || "Something went wrong while updating family");
      return false;
    }
  } catch (error) {
    showErrorToast(error?.message || "Error updating family");
    return false;
  }
}

// Update family address
export async function updateUserFamilyAddress(data) {
  try {
    const response = await updateUserFamilyAddressApi(data);
    if (response?.status === 201 || response?.status === 200) {
      showSuccessToast(response?.data?.message || "UserFamily address updated successfully.");
      return true; // Return true on success
    } else {
      showErrorToast(response?.data?.message || response?.message || "Something went wrong while updating family");
      return false;
    }
  } catch (error) {
    showErrorToast(error?.message || "Something went wrong while updating family address.");
    return false;
  }
}

// Create a new family member
export async function handleCreateUserFamilyMember(data) {
  try {
    const response = await createUserFamilyMemberApi(data);
    if (response?.status === 201 || response?.status === 200) {
      showSuccessToast(response?.data?.message || "UserFamily member created successfully.");
      return true; // Return true on success
    } else {
      showErrorToast(response?.data?.message || response?.message || "Something went wrong while creating family member");
      return false;
    }
  } catch (error) {
    showErrorToast(error?.message || "Something went wrong while creating family member.");
    return false;
  }
}

// Fetch family member by ID
export async function fetchUserFamilyMemberById(familyId) {
  try {
    const response = await getUserFamilyMemberByIdApi(familyId);
    if (response?.status === 200) {
      return response.data; // Return the fetched family member data
    } else {
      showErrorToast(response?.data?.message || response?.message || "Something went wrong while fetching family member");
      return false;
    }
  } catch (error) {
    showErrorToast(error?.message || "Error fetching family member details");
    return false;
  }
}


// Update family member details
export async function updateUserFamilyMember(updatedUserFamilyMemberData) {
  try {
    const response = await updateUserFamilyMemberApi(updatedUserFamilyMemberData);
    if (response?.status === 200 || response?.status === 201) {
      showSuccessToast("UserFamily member updated successfully");
      return true; // Return true on success
    } else {
      showErrorToast(response?.data?.message || response?.message || "Error updating family member");
      return false;
    }
  } catch (error) {
    showErrorToast(error?.message || "Error updating family member");
    return false; // Return true on success
  }
}